export default __webpack_public_path__ + "static/media/image-product-mobile.113818bc.jpg";